import React from 'react';
import CarouselB from 'react-bootstrap/Carousel';
import '../../../Styles/modalPortfolio.css'

const Carousel = ({img1, img2, img3}) => {
    return (
        <div className="o-car-mod">
        <CarouselB>
            <CarouselB.Item>
                <img
                    className="d-block w-100"
                    src={img1}
                    alt="First slide"
                />
            </CarouselB.Item>
            <CarouselB.Item>
                <img
                    className="d-block w-100"
                    src={img2}
                    alt="Second slide"
                />

               
            </CarouselB.Item>
            <CarouselB.Item>
                <img
                    className="d-block w-100"
                    src={img3}
                    alt="Third slide"
                />

                
            </CarouselB.Item>
        </CarouselB>
        </div>
    );
};
export default Carousel;